// extracted by mini-css-extract-plugin
module.exports = {"ChannelModal":"ChannelModal_ChannelModal__1UsqU","SubmitBtn":"ChannelModal_SubmitBtn__N2E_t","BackgroundRed":"ChannelModal_BackgroundRed__3smOJ"};